import { render, staticRenderFns } from "./EditArticleList.vue?vue&type=template&id=0969e5f2"
import script from "./EditArticleList.vue?vue&type=script&lang=js"
export * from "./EditArticleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports